import React from 'react';

function SvgIcon({ size = 20, strokeWidth = 2, children, style, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0, ...style }}
      {...props}
    >
      {children}
    </svg>
  );
}

export function TicketIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 9a2 2 0 0 0 0 6v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3a2 2 0 0 1 0-6V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" />
      <path d="M9 4v16" />
    </SvgIcon>
  );
}

export function GlobeIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a14 14 0 0 1 0 18" />
      <path d="M12 3a14 14 0 0 0 0 18" />
    </SvgIcon>
  );
}

export function PhoneIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
      <path d="M11 18.5h2" />
    </SvgIcon>
  );
}

export function ChartIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M4 19h16" />
      <path d="M7 15v-4" />
      <path d="M12 19V9" />
      <path d="M17 19v-7" />
    </SvgIcon>
  );
}

export function LocationIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 21s-6-5.4-6-11a6 6 0 1 1 12 0c0 5.6-6 11-6 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </SvgIcon>
  );
}

export function SearchIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-4.2-4.2" />
    </SvgIcon>
  );
}

export function HeartIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 20.5 4.8 13.7a4.7 4.7 0 0 1 6.7-6.6L12 7.6l.5-.5a4.7 4.7 0 1 1 6.7 6.6z" />
    </SvgIcon>
  );
}

export function UsersIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16 19a4 4 0 0 0-8 0" />
      <circle cx="12" cy="11" r="3" />
      <path d="M21 19a3.5 3.5 0 0 0-3-3.5" />
      <path d="M3 19a3.5 3.5 0 0 1 3-3.5" />
    </SvgIcon>
  );
}

export function GiftIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13" />
      <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
      <path d="M8.5 8C7 8 6 7.1 6 5.8 6 4.6 6.9 4 8 4c1.8 0 4 2.5 4 4" />
      <path d="M15.5 8c1.5 0 2.5-.9 2.5-2.2C18 4.6 17.1 4 16 4c-1.8 0-4 2.5-4 4" />
    </SvgIcon>
  );
}

export function SettingsIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a2 2 0 0 1-2.8 2.8l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a2 2 0 0 1-4 0v-.2a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.1.1a2 2 0 0 1-2.8-2.8l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a2 2 0 0 1 0-4h.2a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1 1 0 0 0 1.1.2 1 1 0 0 0 .6-.9V4a2 2 0 0 1 4 0v.2a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1 1 0 0 0-.2 1.1 1 1 0 0 0 .9.6H20a2 2 0 0 1 0 4h-.2a1 1 0 0 0-.9.6z" />
    </SvgIcon>
  );
}

export function BellIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15 18H9a2 2 0 0 1-2-2v-4a5 5 0 1 1 10 0v4a2 2 0 0 1-2 2z" />
      <path d="M5 18h14" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </SvgIcon>
  );
}

export function UserIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </SvgIcon>
  );
}

export function MailIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </SvgIcon>
  );
}

export function DocumentIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8 3h6l4 4v14H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M14 3v4h4" />
      <path d="M9 13h6" />
      <path d="M9 17h4" />
    </SvgIcon>
  );
}

export function LockIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </SvgIcon>
  );
}

export function WarningIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 3 2.8 19h18.4L12 3z" />
      <path d="M12 9v5" />
      <path d="M12 18h.01" />
    </SvgIcon>
  );
}

export function CameraIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M4 8h4l2-2h4l2 2h4v11H4z" />
      <circle cx="12" cy="13.5" r="3.5" />
    </SvgIcon>
  );
}

export function ImageIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.5" />
      <path d="m21 16-5.5-5.5L7 19" />
    </SvgIcon>
  );
}

export function HandshakeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M7 12 4 9a2.5 2.5 0 0 1 0-3.5L5.5 4 10 8.5" />
      <path d="m17 12 3-3a2.5 2.5 0 0 0 0-3.5L18.5 4 14 8.5" />
      <path d="m8.5 10.5 2 2a2 2 0 0 0 2.8 0l4.7-4.7" />
      <path d="m9 15 1.5 1.5a2 2 0 0 0 2.8 0L15 15" />
    </SvgIcon>
  );
}

export function MegaphoneIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="m4 12 11-5v10L4 12z" />
      <path d="M15 9h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3" />
      <path d="M7 13v4a2 2 0 0 0 2 2h1" />
    </SvgIcon>
  );
}

export function SparklesIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="m12 3 1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8L12 3z" />
      <path d="m5 16 .9 2.1L8 19l-2.1.9L5 22l-.9-2.1L2 19l2.1-.9L5 16z" />
      <path d="m19 14 .7 1.6L21.3 16l-1.6.7L19 18.3l-.7-1.6L16.7 16l1.6-.7L19 14z" />
    </SvgIcon>
  );
}

export function RocketIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M5 19c1.5-2.5 4-4 7-4 0-3 1.5-5.5 4-7l3-3 1 4-3 3c-1.5 2.5-4 4-7 4-2 3-4.5 5.5-8 7z" />
      <path d="M9 15 5 19" />
      <circle cx="15" cy="9" r="1.5" />
    </SvgIcon>
  );
}

export function CalendarIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M16 3v4" />
      <path d="M8 3v4" />
      <path d="M3 10h18" />
    </SvgIcon>
  );
}

export function CardIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M3 10h18" />
      <path d="M7 15h3" />
    </SvgIcon>
  );
}

export function VolumeOffIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M11 5 7.5 8H4v8h3.5L11 19z" />
      <path d="m16 9 5 6" />
      <path d="m21 9-5 6" />
    </SvgIcon>
  );
}

export function VolumeOnIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M11 5 7.5 8H4v8h3.5L11 19z" />
      <path d="M16 9a4.5 4.5 0 0 1 0 6" />
      <path d="M18.5 6.5a8 8 0 0 1 0 11" />
    </SvgIcon>
  );
}

export function CheckIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="m5 12 4 4L19 6" />
    </SvgIcon>
  );
}

export function CloseIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18 6 6 18" />
      <path d="M6 6l12 12" />
    </SvgIcon>
  );
}

export function StarIcon(props) {
  return (
    <SvgIcon {...props}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </SvgIcon>
  );
}

export function EditIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </SvgIcon>
  );
}

export function EyeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </SvgIcon>
  );
}

export function EyeOffIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <path d="M1 1l22 22" />
    </SvgIcon>
  );
}

export function ShareIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
      <polyline points="16 6 12 2 8 6" />
      <line x1="12" y1="2" x2="12" y2="15" />
    </SvgIcon>
  );
}

export function ZapIcon(props) {
  return (
    <SvgIcon {...props}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </SvgIcon>
  );
}

export function StarFilledIcon(props) {
  return (
    <SvgIcon {...props}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="currentColor" />
    </SvgIcon>
  );
}

export function ClipboardIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" />
    </SvgIcon>
  );
}

export function AppleIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18 20a6 6 0 0 0-6-6 6 6 0 0 0-6 6" />
      <circle cx="12" cy="12" r="6" />
      <path d="M12 8v4l3 2" />
    </SvgIcon>
  );
}

export function MailIcon2(props) {
  return (
    <SvgIcon {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </SvgIcon>
  );
}

export function VideoIcon(props) {
  return (
    <SvgIcon {...props}>
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </SvgIcon>
  );
}

export function TimerIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="13" r="9" />
      <polyline points="12 9 12 13 15 15" />
      <path d="M9 2h6" />
    </SvgIcon>
  );
}

export function FireIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8.5 14.5C6 12 5 9 5 6a7 7 0 1 1 14 0c0 3-1 6-3.5 8.5M12 19v2" />
    </SvgIcon>
  );
}

export function MusicIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 18v-13h6v13M9 5h6" />
      <circle cx="6" cy="18" r="2" />
      <circle cx="15" cy="18" r="2" />
    </SvgIcon>
  );
}

export function BuildingIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M4 21h16M4 3h16v16H4z" />
      <path d="M9 7h2v2H9z" />
      <path d="M13 7h2v2h-2z" />
      <path d="M9 12h2v2H9z" />
      <path d="M13 12h2v2h-2z" />
    </SvgIcon>
  );
}

export function MoneyIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <circle cx="12" cy="12" r="3" />
      <path d="M6 12h2M16 12h2" />
    </SvgIcon>
  );
}

export function InfoIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </SvgIcon>
  );
}

export function EmailIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m4 6 8 6 8-6" />
    </SvgIcon>
  );
}

export function PartyIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 1v6M4 8l4 4M20 8l-4 4M12 18l-3 3M12 18l3 3M7 20l2-5M17 20l-2-5" />
      <circle cx="6" cy="6" r="2" />
      <circle cx="18" cy="6" r="2" />
    </SvgIcon>
  );
}
